/**
 * Created by xixue on 2018/3/24.
 */
/* 匹配测试环境正式环境api */
let root = process.env.CH_API_ROOT
let rootUrl = window.location.host
switch (rootUrl) {
  case 'module-cn.classba.cn':  // 正式环境线下
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.classba.cn'
    break
  case 'module-cn.171xue.com':// 正式环境线上
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.171xue.com'
    break
  case 'module-cn.test.classba.cn':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  case 'module-cn.test.171xue.com':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.171xue.com'
    break
  // case 'test-math-web.classba.cn': //废弃
  //   root = '//test-s-math.classba-cn.cn'
  //   break
  case 'localhost:8080':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  case '10.173.1.188:8080':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  case 'me.classba.cn:8080':
    root = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  default:
    // root = (window.location.protocol === 'https:' ? 'https://' : 'http://') +'module-api-cn.classba.cn'
    root = 'http://module-api-cn.test.classba.cn'
}

/* 匹配测试环境正式环境api */
let root2 = process.env.API_ROOT
switch (rootUrl) {
  case 'module-cn.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.classba.cn'
    break
  case 'module-cn.171xue.com':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.171xue.com'
    break
  case 'module-cn.test.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.test.classba.cn'
    break
  case 'module-cn.test.171xue.com':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.test.171xue.com'
    break
  case 'math-web.test.classba.cn':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 's-math.test.classba.cn'
    break
  case 'localhost:8080':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  case '10.173.1.188:8080':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  case 'me.classba.cn:8080':
    root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api-cn.test.classba.cn'
    break
  default:
    root = 'http://module-api-cn.test.classba.cn'
  // root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'module-api.classba.cn'

  // root = 'http://172.16.18.99/index.php'
    // root2 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-module-api.classba.cn'
}

let root3 = process.env.API_ROOT
switch (rootUrl) {
  case 'cn-new.classba.cn':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.classba.cn'
    break
  case 'cn-new.171xue.com':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.classba.cn'
    break
  case 'cn-new.test.classba.cn':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  case 'cn-new.test.171xue.com':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  case 'math-web.test.classba.cn':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  case 'localhost:8080':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  case '10.173.1.188:8080':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  case 'me.classba.cn:8080':
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
    break
  default:
    root3 = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'wacom.test.classba.cn'
}

export {root, root2, root3}



// WEBPACK FOOTER //
// ./src/utils/chHostconfig.js